import { ShoppingCart, Package, Award, DollarSign, Truck, Clock } from "lucide-react";
import BgImage from "@/assets/img/sted-delivery.png";

export const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      icon: <ShoppingCart size={24} className='text-primary' />,
      title: "Convenience",
      description:
        "Shop from the comfort of your home or workplace, saving you the time and stress of visiting physical stores.",
    },
    {
      id: 2,
      icon: <Package size={24} className='text-primary' />,
      title: "Wide Product Range",
      description:
        "Extensive selection of premium quality products with options to fit every style and budget.",
    },
    {
      id: 3,
      icon: <Award size={24} className='text-primary' />,
      title: "Quality Assurance",
      description:
        "We're committed to providing high-quality products with every order. We offer a return or refund within 7 days of delivery.",
    },
    {
      id: 4,
      icon: <DollarSign size={24} className='text-primary' />,
      title: "Cost Savings",
      description:
        "Enjoy competitive prices, regular promotions, and exclusive deals that help maximize your savings.",
    },
    {
      id: 5,
      icon: <Truck size={24} className='text-primary' />,
      title: "Fast Delivery",
      description:
        "Reliable and speedy shipping with real-time tracking to ensure your purchases arrive promptly.",
    },
    {
      id: 6,
      icon: <Clock size={24} className='text-primary' />,
      title: "24/7 Support",
      description:
        "Our dedicated customer service team is available round the clock to address your queries and concerns.",
    },
  ];

  return (
    <section className='py-16 bg-primary/20'>
      <div className='container mx-auto px-4'>
        {/* Section Header */}
        <div className='text-center mb-12'>
          <h2 className='text-primary text-xl font-semibold uppercase tracking-wider mb-2'>
            Why Choose Us
          </h2>
          <h3 className='text-3xl font-bold text-gray-800 max-w-3xl mx-auto'>
            Discover why we are your ultimate online shopping destination
          </h3>
        </div>

        {/* Content with image on left, features on right */}
        <div className='flex flex-col lg:flex-row gap-10 items-center'>
          {/* Left side - Image */}
          <div className='lg:w-4/12'>
            <div className='relative'>
              <img
                src={BgImage}
                alt='Happy customer with shopping bag'
                className='rounded-lg shadow-lg object-cover h-[500px] w-full'
              />
              <div className='absolute -bottom-6 -right-6 bg-secondary text-white p-4 rounded-lg shadow-lg hidden md:block'>
                <p className='font-bold text-lg'>100%</p>
                <p className='text-sm'>Customer Satisfaction</p>
              </div>
            </div>
          </div>

          {/* Right side - Feature list */}
          <div className='lg:w-7/12'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
              {features.map((feature) => (
                <div key={feature.id} className='flex gap-4 items-start'>
                  <div className='shrink-0 bg-white p-3 rounded-full shadow-md'>{feature.icon}</div>
                  <div>
                    <h4 className='text-xl font-semibold mb-2'>{feature.title}</h4>
                    <p className='text-gray-600'>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
